export default "__VITE_ASSET__BwjPpLwE__";